import { connect } from 'react-redux'
import Table from './Table'

import onChangeTable from './Handlers/onChangeTable'

const mapStateToProps = (state) => ({
  subInvoices: state.screens.Subbies.SubInvoices.subInvoices,
  fetching: state.screens.Subbies.SubInvoices.fetching,
  pagination: state.screens.Subbies.SubInvoices.pagination,
})

const actionCreators = {
  onChangeTable,
}

export default connect(mapStateToProps, actionCreators)(Table)
